import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

/**
 * Thin wrapper around Material Symbols Outlined.
 * The font is loaded globally in `src/styles.scss`.
 */
@Component({
  selector: 'app-ui-icon',
  imports: [],
  templateUrl: './ui-icon.component.html',
  styleUrl: './ui-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiIconComponent {
  /** Material Symbols ligature name, e.g. `check_circle`. */
  readonly name = input.required<string>();
  /** Rendered glyph size in px. Drives both `font-size` and optical size. */
  readonly size = input<number>(20);
  /** Optional CSS color; defaults to `inherit`. */
  readonly color = input<string>();
  /** Glyph fill (`0` outlined, `1` filled). Defaults to outlined. */
  readonly fill = input<number>(0);
  /** Optional native tooltip shown on hover (maps to the `title` attribute). */
  readonly title = input<string>();

  protected readonly fontVariationSettings = computed(
    () => `'FILL' ${this.fill()}, 'wght' 400, 'GRAD' 0, 'opsz' ${this.size()}`,
  );
}
